var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfEmployed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#2450ff;}.c,.e{fill:none;}.c{stroke:#6dcef8;stroke-width:2px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1140 -1505)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1157 1505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60,29H0A27.993,27.993,0,0,1,2.358,17.711,28.862,28.862,0,0,1,8.787,8.493a29.994,29.994,0,0,1,9.536-6.215,31.062,31.062,0,0,1,23.355,0,29.97,29.97,0,0,1,9.535,6.215,28.871,28.871,0,0,1,6.429,9.218A28,28,0,0,1,60,29Z",
    transform: "translate(1140 1536)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1175 1548)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H12a0,0,0,0,1,0,0V6a6,6,0,0,1-6,6H6A6,6,0,0,1,0,6V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2,1h8a1,1,0,0,1,1,1V6a5,5,0,0,1-5,5H6A5,5,0,0,1,1,6V2A1,1,0,0,1,2,1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfEmployed);
export default __webpack_public_path__ + "static/media/self-employed.147ac8fe97f5de7d1bb6729672304dd2.svg";
export { ForwardRef as ReactComponent };